const ta = {
  common: {
    home: "முகப்பு",
    materials: "பொருட்கள்",
    rateCard: "விலை அட்டை",
    cart: "கார்ட்",
    myBookings: "என் முன்பதிவுகள்",
    login: "உள்நுழை",
    signup: "பதிவு செய்",
    dashboard: "டாஷ்போர்டு",
    settings: "அமைப்புகள்",
    logout: "வெளியேறு",
    save: "சேமிக்கவும்",
    loading: "ஏற்றப்படுகிறது...",
  },
  header: {
    brand: "மிஸ்த்ரிபஜார்",
  },
  settings: {
    title: "அமைப்புகள்",
    subtitle: "உங்கள் சுயவிவரம், மொழி, முகவரி மற்றும் கணக்கு அமைப்புகளை நிர்வகிக்கவும்.",
    profileSection: "சுயவிவரம்",
    languageSection: "மொழி",
    addressSection: "சேமிக்கப்பட்ட முகவரி",
    accountSection: "கணக்கு",
    fullName: "முழு பெயர்",
    phone: "தொலைபேசி எண்",
    email: "மின்னஞ்சல்",
    city: "நகரம்",
    preferredLanguage: "விருப்ப மொழி",
    flatHouseNo: "பிளாட் / வீட்டு எண்",
    streetArea: "தெரு / பகுதி",
    state: "மாநிலம்",
    country: "நாடு",
    pincode: "பின் கோடு",
    role: "பங்கு",
    uniqueId: "யுனிக் ஐடி",
    saveProfile: "சுயவிவரம் சேமிக்கவும்",
    saveAddress: "முகவரி சேமிக்கவும்",
    accountDetails: "கணக்கு விவரங்கள்",
  },
  home: {
    heroTitle: "மிஸ்த்ரிபஜார்",
    heroText:
      "சேவைகளை முன்பதிவு செய்யுங்கள், பொருட்கள் வாங்குங்கள், உங்கள் வீட்டை கட்டுங்கள், மற்றும் உள்ளூர் ஒருங்கிணைப்பு, மறைந்த செலவுகள் மற்றும் உறுதி இல்லாத காலக்கெடு சிக்கல்களை குறைக்குங்கள்.",
    buyMaterials: "பொருட்கள் வாங்குங்கள்",
    buildYourHouse: "உங்கள் வீட்டை கட்டுங்கள்",
    exploreMembership: "உறுப்பினத்தை பார்க்கவும்",
    services: "சேவைகள்",
    about: "எங்களை பற்றி",
    contactUs: "தொடர்பு கொள்ளுங்கள்",
    privacyPolicy: "தனியுரிமைக் கொள்கை",
    terms: "விதிமுறைகள் & நிபந்தனைகள்",
  },
};

export default ta;